import { render, staticRenderFns } from "./accessManage.vue?vue&type=template&id=081ee813&scoped=true"
import script from "./accessManage.vue?vue&type=script&lang=js"
export * from "./accessManage.vue?vue&type=script&lang=js"
import style0 from "./accessManage.vue?vue&type=style&index=0&id=081ee813&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "081ee813",
  null
  
)

export default component.exports